
export const downloadLoanSummaryErrorFile: any = (rowData: any, fileId: string, args: any[]) => {
  if (rowData["type"] === "PDC") {
    return "loan/platform/document/generate-url-info/" + fileId;
  } else if (rowData["type"] === "DELETE ALLOCATION" || rowData["type"] === "TRACE ALLOCATION" || rowData["type"] === "TRACE DELETE ALLOCATION") {
    return "loan/platform/document/generate-url-info/" + rowData["errorFileId"];
  } else {
    return "loanallocation/generate-url-info/errors/" + fileId;
  }
};
